/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as cameraV1 from "./keyapis_vc_camera_v1.pb"

/**
 * Спецификация для получения данных o местонахождении камеры
 */

/**
 * Сервис получения данных o местонахождении камеры
 */
export class CameraLocationDataServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения данных o местонахождении камеры.
   * Метод доступен для: ApiKey
   */
  GetCameraLocationData = (req: GetCameraLocationDataRequestDto, init?: RequestInit): Promise<GetCameraLocationDataResponseDto> => {
    return fm.request<GetCameraLocationDataRequestDto, GetCameraLocationDataResponseDto>(`${this.host}/vc/api/v1/camera_location_data/${encodeURIComponent(req.uid)}${fm.buildQuery(req, ["uid"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип устройства
 */
export enum CameraLocationDataDeviceType {
  /**
   * Значение не указано
   */
  DEVICE_TYPE_UNKNOWN = "DEVICE_TYPE_UNKNOWN",
  /**
   * Домофон
   */
  INTERCOM = "INTERCOM",
  /**
   * Видеокамера
   */
  VIDEOCAMERA = "VIDEOCAMERA",
  /**
   * Шлагбаум
   */
  BARRIER = "BARRIER",
  /**
   * Калитка
   */
  GATE = "GATE",
  /**
   * СКУД
   */
  ACCESS_CONTROL_PANEL = "ACCESS_CONTROL_PANEL",
  /**
   * Наружняя видеокамера
   */
  OUTDOOR_CAMERA = "OUTDOOR_CAMERA",
}
/**
 * Тип устройства
 */
export type CameraLocationDataDeviceTypeResponseEnum = keyof typeof CameraLocationDataDeviceType
/**
 * Тип устройства
 */
export type CameraLocationDataDeviceTypeRequestEnum = Exclude<CameraLocationDataDeviceTypeResponseEnum, "DEVICE_TYPE_UNKNOWN">;

/**
 * Справочник статусов устройства
 */
export enum CameraLocationDataStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Не в сети
   */
  OFFLINE = "OFFLINE",
  /**
   * В сети
   */
  ONLINE = "ONLINE",
}
/**
 * Справочник статусов устройства
 */
export type CameraLocationDataStatusTypeResponseEnum = keyof typeof CameraLocationDataStatusType
/**
 * Справочник статусов устройства
 */
export type CameraLocationDataStatusTypeRequestEnum = Exclude<CameraLocationDataStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Данные o местонахождении камеры
 */
export type CameraLocationDataRequestDto = {
  /**
   * Идентификатор видеопотока в системе Видеокомфорт.
   * Тип: Guid
   */
  uid: string
  /**
   * Тип устройства.
   */
  deviceType?: CameraLocationDataDeviceTypeRequestEnum | "DEVICE_TYPE_UNKNOWN"
  /**
   * Модель устройства
   */
  model?: string
  /**
   * Серийный номер устройства
   */
  serialNumber?: string
  /**
   * Версия аппаратного обеспечения
   */
  hwVersion?: string
  /**
   * Версия программного обеспечения
   */
  swVersion?: string
  /**
   * MAC-адрес.
   * # Диапазон: 17..17.
   * # Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
   */
  mac?: string
  /**
   * Наименование устройства.
   * # Диапазон: 3..256
   */
  title?: string
  /**
   * Сетевой адрес.
   * # Диапазон: 0..250
   */
  host?: string
  /**
   * Статус устройства
   */
  statusType?: CameraLocationDataStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
  /**
   * Номер подъезда.
   * # Диапазон: 1..100
   */
  entranceNumbers?: number[]
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId?: number
  /**
   * Компания владелец устройства
   */
  company?: CameraLocationDataCompanyRequestDto | null
  /**
   * Массив домов камеры
   */
  buildings?: CameraLocationDataBuildingRequestDto[]
}
/**
 * Данные o местонахождении камеры
 */
export type CameraLocationDataResponseDto = {
  /**
   * Идентификатор видеопотока в системе Видеокомфорт.
   * Тип: Guid
   */
  uid: string
  /**
   * Тип устройства.
   */
  deviceType: CameraLocationDataDeviceTypeResponseEnum
  /**
   * Модель устройства
   */
  model: string
  /**
   * Серийный номер устройства
   */
  serialNumber: string
  /**
   * Версия аппаратного обеспечения
   */
  hwVersion: string
  /**
   * Версия программного обеспечения
   */
  swVersion: string
  /**
   * MAC-адрес.
   * # Диапазон: 17..17.
   * # Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
   */
  mac: string
  /**
   * Наименование устройства.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Сетевой адрес.
   * # Диапазон: 0..250
   */
  host: string
  /**
   * Статус устройства
   */
  statusType: CameraLocationDataStatusTypeResponseEnum
  /**
   * Номер подъезда.
   * # Диапазон: 1..100
   */
  entranceNumbers: number[]
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Компания владелец устройства
   */
  company: CameraLocationDataCompanyResponseDto | null
  /**
   * Массив домов камеры
   */
  buildings: CameraLocationDataBuildingResponseDto[]
}
/**
 * Дом
 */
export type CameraLocationDataBuildingRequestDto = {
  /**
   * Идентификатор дома
   */
  id?: number
  /**
   * Идентификатор РФ
   */
  rfId: number
  /**
   * Идентификатор МРФ
   */
  mrfId: number
  /**
   * ОРПОН
   */
  orpon: string
  /**
   * Город
   */
  city: string
  /**
   * Улица
   */
  street: string
  /**
   * Номер дома
   */
  number?: string
  /**
   * Корпус
   */
  part?: string
  /**
   * Идентификатор компании
   */
  companyId: number
  /**
   * Префикс
   */
  prefix?: string
  /**
   * Идентификатор квартирограммы
   */
  flatgrammId: number
  /**
   * ОРПОН города, в котором находится дом
   */
  cityOrpon?: string
  /**
   * Идентификатор в федеральной информационной адресной системе.
   * Тип: Guid
   */
  fias?: string
  /**
   * Наименования района.
   * # Диапазон: 0..200
   */
  district?: string
  /**
   * Уникальный номер адреса.
   * # Диапазон: 0..9999999999
   */
  unom?: string
  /**
   * ОРПОН региона
   */
  regionOrpon?: string
}
/**
 * Дом
 */
export type CameraLocationDataBuildingResponseDto = {
  /**
   * Идентификатор дома
   */
  id: number
  /**
   * Идентификатор РФ
   */
  rfId: number
  /**
   * Идентификатор МРФ
   */
  mrfId: number
  /**
   * ОРПОН
   */
  orpon: string
  /**
   * Город
   */
  city: string
  /**
   * Улица
   */
  street: string
  /**
   * Номер дома
   */
  number: string
  /**
   * Корпус
   */
  part: string
  /**
   * Идентификатор компании
   */
  companyId: number
  /**
   * Префикс
   */
  prefix: string
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата удаления.
   * # Тип: DateTime
   */
  readonly deletedAt: string | null
  /**
   * Идентификатор квартирограммы
   */
  flatgrammId: number
  /**
   * ОРПОН города, в котором находится дом
   */
  cityOrpon: string
  /**
   * Идентификатор в федеральной информационной адресной системе.
   * Тип: Guid
   */
  fias: string
  /**
   * Наименования района.
   * # Диапазон: 0..200
   */
  district: string
  /**
   * Уникальный номер адреса.
   * # Диапазон: 0..9999999999
   */
  unom: string
  /**
   * ОРПОН региона
   */
  regionOrpon: string
}
/**
 * Компания
 */
export type CameraLocationDataCompanyRequestDto = {
  /**
   * Идентификатор компании.
   * # Диапазон: 1..2147483647
   */
  id?: number
  /**
   * Идентификатор компании в системе Видеокомфорт
   */
  vcCompanyId?: string
  /**
   * Наименование компании
   */
  name?: string
  /**
   * ИНН
   */
  inn?: string
  /**
   * КПП
   */
  kpp?: string
  /**
   * ОГРН
   */
  ogrn?: string
}
/**
 * Компания
 */
export type CameraLocationDataCompanyResponseDto = {
  /**
   * Идентификатор компании.
   * # Диапазон: 1..2147483647
   */
  id: number
  /**
   * Идентификатор компании в системе Видеокомфорт
   */
  vcCompanyId: string
  /**
   * Наименование компании
   */
  name: string
  /**
   * ИНН
   */
  inn: string
  /**
   * КПП
   */
  kpp: string
  /**
   * ОГРН
   */
  ogrn: string
}
/**
 * Запрос на получение данных o местонахождении камеры
 */
export type GetCameraLocationDataRequestDto = {
  /**
   * uid видеопотока камеры
   */
  uid: string
}
/**
 * Ответ на запрос на получение данных o местонахождении камеры
 */
export type GetCameraLocationDataResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Данные o местонахождении камеры
   */
  readonly data: CameraLocationDataResponseDto
  /**
   * Ошибка
   */
  readonly error: GetCameraLocationDataResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraLocationDataResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type GetCameraLocationDataResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: cameraV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Данные o местонахождении камеры
   */
  "CameraLocationData": {
    "kind": "class",
    "text": "Данные o местонахождении камеры",
    "fields": {
      /**
       * Идентификатор видеопотока в системе Видеокомфорт.
       * Тип: Guid
       */
      "uid": {
        "type": "string",
        "text": "Идентификатор видеопотока в системе Видеокомфорт.\nТип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип устройства.
       */
      "deviceType": {
        "type": "CameraLocationData.DeviceType",
        "text": "Тип устройства.",
      },
      /**
       * Модель устройства
       */
      "model": {
        "type": "string",
        "text": "Модель устройства",
      },
      /**
       * Серийный номер устройства
       */
      "serialNumber": {
        "type": "string",
        "text": "Серийный номер устройства",
      },
      /**
       * Версия аппаратного обеспечения
       */
      "hwVersion": {
        "type": "string",
        "text": "Версия аппаратного обеспечения",
      },
      /**
       * Версия программного обеспечения
       */
      "swVersion": {
        "type": "string",
        "text": "Версия программного обеспечения",
      },
      /**
       * MAC-адрес.
       * # Диапазон: 17..17.
       * # Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
       */
      "mac": {
        "type": "string",
        "text": "MAC-адрес.\n# Диапазон: 17..17.\n# Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/",
        "rules": {
          "minLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Минимум: 17"
          },
          "maxLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Максимум: 17"
          },
          "pattern": {
            "value": /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/"
          }
        }
      },
      /**
       * Наименование устройства.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Наименование устройства.\n# Диапазон: 3..256",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Сетевой адрес.
       * # Диапазон: 0..250
       */
      "host": {
        "type": "string",
        "text": "Сетевой адрес.\n# Диапазон: 0..250",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 250,
            "message": "Значение не входит в допустимый диапазон. Максимум: 250"
          },
        }
      },
      /**
       * Статус устройства
       */
      "statusType": {
        "type": "CameraLocationData.StatusType",
        "text": "Статус устройства",
      },
      /**
       * Номер подъезда.
       * # Диапазон: 1..100
       */
      "entranceNumbers": {
        "type": "int32",
        "text": "Номер подъезда.\n# Диапазон: 1..100",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Идентификатор квартирограммы.
       * # Диапазон: 1..2147483647
       */
      "flatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Компания владелец устройства
       */
      "company": {
        "type": "CameraLocationData.Company",
        "text": "Компания владелец устройства",
      },
      /**
       * Массив домов камеры
       */
      "buildings": {
        "type": "CameraLocationData.Building",
        "text": "Массив домов камеры",
      },
    },
  },
  /**
   * Дом
   */
  "CameraLocationData.Building": {
    "kind": "class",
    "text": "Дом",
    "fields": {
      /**
       * Идентификатор дома
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор дома",
      },
      /**
       * Идентификатор РФ
       */
      "rfId": {
        "type": "int32",
        "text": "Идентификатор РФ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор МРФ
       */
      "mrfId": {
        "type": "int32",
        "text": "Идентификатор МРФ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Город
       */
      "city": {
        "type": "string",
        "text": "Город",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Улица
       */
      "street": {
        "type": "string",
        "text": "Улица",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер дома
       */
      "number": {
        "type": "string",
        "text": "Номер дома",
      },
      /**
       * Корпус
       */
      "part": {
        "type": "string",
        "text": "Корпус",
      },
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "int32",
        "text": "Идентификатор компании",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Префикс
       */
      "prefix": {
        "type": "string",
        "text": "Префикс",
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime",
      },
      /**
       * Идентификатор квартирограммы
       */
      "flatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН города, в котором находится дом
       */
      "cityOrpon": {
        "type": "int64",
        "text": "ОРПОН города, в котором находится дом",
      },
      /**
       * Идентификатор в федеральной информационной адресной системе.
       * Тип: Guid
       */
      "fias": {
        "type": "string",
        "text": "Идентификатор в федеральной информационной адресной системе.\nТип: Guid",
      },
      /**
       * Наименования района.
       * # Диапазон: 0..200
       */
      "district": {
        "type": "string",
        "text": "Наименования района.\n# Диапазон: 0..200",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 200,
            "message": "Значение не входит в допустимый диапазон. Максимум: 200"
          },
        }
      },
      /**
       * Уникальный номер адреса.
       * # Диапазон: 0..9999999999
       */
      "unom": {
        "type": "string",
        "text": "Уникальный номер адреса.\n# Диапазон: 0..9999999999",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 9999999999,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9999999999"
          },
        }
      },
      /**
       * ОРПОН региона
       */
      "regionOrpon": {
        "type": "int64",
        "text": "ОРПОН региона",
      },
    },
  },
  /**
   * Компания
   */
  "CameraLocationData.Company": {
    "kind": "class",
    "text": "Компания",
    "fields": {
      /**
       * Идентификатор компании.
       * # Диапазон: 1..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор компании.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатор компании в системе Видеокомфорт
       */
      "vcCompanyId": {
        "type": "int64",
        "text": "Идентификатор компании в системе Видеокомфорт",
      },
      /**
       * Наименование компании
       */
      "name": {
        "type": "string",
        "text": "Наименование компании",
      },
      /**
       * ИНН
       */
      "inn": {
        "type": "string",
        "text": "ИНН",
      },
      /**
       * КПП
       */
      "kpp": {
        "type": "string",
        "text": "КПП",
      },
      /**
       * ОГРН
       */
      "ogrn": {
        "type": "string",
        "text": "ОГРН",
      },
    },
  },
  /**
   * Запрос на получение данных o местонахождении камеры
   */
  "GetCameraLocationDataRequest": {
    "kind": "class",
    "text": "Запрос на получение данных o местонахождении камеры",
    "fields": {
      /**
       * uid видеопотока камеры
       */
      "uid": {
        "type": "string",
        "text": "uid видеопотока камеры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на получение данных o местонахождении камеры
   */
  "GetCameraLocationDataResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение данных o местонахождении камеры",
    "fields": {
      /**
       * Данные o местонахождении камеры
       */
      "data": {
        "type": "CameraLocationData",
        "text": "Данные o местонахождении камеры",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetCameraLocationDataResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "GetCameraLocationDataResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Тип устройства
   */
  "CameraLocationData.DeviceType": {
    "kind": "enum",
    "text": "Тип устройства",
    "values": {
      /**
       * Значение не указано
       */
      "DEVICE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Домофон
       */
      "INTERCOM": {
        "i": 1,
        "text": "Домофон",
      },
      /**
       * Видеокамера
       */
      "VIDEOCAMERA": {
        "i": 2,
        "text": "Видеокамера",
      },
      /**
       * Шлагбаум
       */
      "BARRIER": {
        "i": 3,
        "text": "Шлагбаум",
      },
      /**
       * Калитка
       */
      "GATE": {
        "i": 4,
        "text": "Калитка",
      },
      /**
       * СКУД
       */
      "ACCESS_CONTROL_PANEL": {
        "i": 5,
        "text": "СКУД",
      },
      /**
       * Наружняя видеокамера
       */
      "OUTDOOR_CAMERA": {
        "i": 6,
        "text": "Наружняя видеокамера",
      },
    },
  },
  /**
   * Справочник статусов устройства
   */
  "CameraLocationData.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов устройства",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Не в сети
       */
      "OFFLINE": {
        "i": 1,
        "text": "Не в сети",
      },
      /**
       * В сети
       */
      "ONLINE": {
        "i": 2,
        "text": "В сети",
      },
    },
  },
}